function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from '../utils/classNames';
import LoadingItem from './LoadingItem';
var MAX_STRAND_ITEMS = 6;
/**
 * Responsible for displaying the transient states (loading and error) for a Strand
 */

var StrandStates = /*#__PURE__*/function (_PureComponent) {
  _inherits(StrandStates, _PureComponent);

  var _super = _createSuper(StrandStates);

  function StrandStates() {
    _classCallCheck(this, StrandStates);

    return _super.apply(this, arguments);
  }

  _createClass(StrandStates, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          full = _this$props.full,
          itemWidth = _this$props.itemWidth,
          loading = _this$props.loading,
          errorMessage = _this$props.errorMessage,
          loadingItem = _this$props.loadingItem,
          singleFrame = _this$props.singleFrame;
      return /*#__PURE__*/React.createElement("div", {
        "data-qa": qa,
        className: "psw-l-anchor psw-clip"
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames(singleFrame && 'psw-single-frame', 'psw-l-section', !full && 'psw-clip')
      }, /*#__PURE__*/React.createElement("div", {
        className: "psw-l-space-x-5 psw-l-line-left psw-p-y-4"
      }, _toConsumableArray(Array(MAX_STRAND_ITEMS)).map(function (_, i) {
        return /*#__PURE__*/React.createElement("div", {
          key: i,
          "data-qa": "".concat(qa, "#placeholder").concat(i),
          "aria-hidden": "true",
          className: classNames(itemWidth, errorMessage && 'psw-hidden')
        }, loadingItem || /*#__PURE__*/React.createElement(LoadingItem, {
          lineCount: 2
        }));
      }))), !loading && errorMessage && /*#__PURE__*/React.createElement("div", {
        "aria-live": "polite",
        className: "psw-l-anchor-center",
        "data-qa": "".concat(qa, "#error")
      }, errorMessage));
    }
  }]);

  return StrandStates;
}(PureComponent);

StrandStates.defaultProps = {
  qa: 'strand',
  full: false,
  loading: false,
  errorMessage: '',
  loadingItem: null,
  singleFrame: false
};
StrandStates.propTypes = {
  /**
   * Unique id used for qa automation. This should be unique to the page
   */
  qa: PropTypes.string,

  /**
   * Whether the strand is full width
   */
  full: PropTypes.bool,

  /**
   * The width classes to apply
   */
  itemWidth: PropTypes.string.isRequired,

  /**
   * Whether the strand should be shown in a loading state
   */
  loading: PropTypes.bool,

  /**
   * The inline error message to display of the space maintained for the strand
   */
  errorMessage: PropTypes.node,

  /**
   * The loading UI to show per placeholder item in the strand
   */
  loadingItem: PropTypes.node,

  /**
   * Setting to use SingleFrameStrand class names
   */
  singleFrame: PropTypes.bool
};
export default StrandStates;